import { Component } from "@angular/core";

@Component({
	selector: "bp-info",
	templateUrl: "./bp-info.component.html",
	styleUrls: ["./bp-info.component.scss"],
	standalone: false
})
export class BpInfoComponent {}
